module.exports = __webpack_public_path__ + "static/media/2013_aug_miles.4fccbc85.pdf";